import PropTypes from "prop-types";
import { useState } from "react";
import { motion } from "framer-motion";
import "./Table.css";
import { useParams } from "react-router-dom";
import { useEvent } from "hooks/useEvent";
import { useAuth } from "hooks/useAuth";
import Text from "components/Common/Text";
import { MatchPlayHeader } from "./MatchPlayHeader";

import MatchPlayMatchTabScorecard from "./SectionRender";
import { BallSwitch } from "./BallSwitch";
import {
  MultipleTeeTimeMatchPlayTab,
  ResultsPending,
} from "./MultipleTeeTimeMatchPlayTab";

export default function MatchPlay({
  data: individualData,
  teams: teamsData,
  teamsPlay,
  numberOfTeeTimes,
  ballCount,
  competedMatch,
}) {
  const { user } = useAuth();
  const { uid } = user;
  const { eventId } = useParams();
  const event = useEvent(eventId);

  const { stake } = event || 0;

  const [activeTab, setActiveTab] = useState(0);
  const tabs = ballCount === 0 ? ["Ball 1"] : ["Ball 1", "Ball 2"];

  const findTeamByUid = (data, userId) =>
    teamsData.find(
      (team) => team.users && team.users.some((u) => u.uid === uid),
    ) ??
    data?.[0]?.find(
      (team) => team.users && team.users.some((u) => u.uid === userId),
    ) ??
    false;

  const holeRemaining = () => {
    const playingUser = teamsPlay
      ? findTeamByUid(teamsData, uid)
      : individualData?.find((u) => u?.uid === uid);

    const holesLength = playingUser?.matches?.[0]?.holes?.length ?? 0;

    if (holesLength === 0) {
      return 18;
    }
    if (holesLength === 17) {
      return 1;
    }
    return 18 - holesLength;
  };

  // eslint-disable-next-line no-unused-vars
  const renderItem = (_ball1) => (
    <motion.div layout style={{ overflow: "auto" }}>
      {_ball1 ? (
        <MultipleTeeTimeMatchPlayTab teamsData={teamsData} ball2 />
      ) : (
        <MultipleTeeTimeMatchPlayTab teamsData={teamsData} ball2={false} />
      )}
    </motion.div>
  );

  const isNotFullTeamMatch = teamsPlay && event?.players.length < 2;

  const isStartedTeamMatch = teamsPlay && teamsData.some((tm) => tm.matches);

  if (
    teamsPlay &&
    numberOfTeeTimes === 1 &&
    !isStartedTeamMatch &&
    !competedMatch
  ) {
    return !isNotFullTeamMatch ? (
      <ResultsPending title="Please input holes" gifTheme="USGA" />
    ) : (
      <Text as="H2" ta="center" style={{ color: "black", padding: 20 }}>
        Please ensure all tee time users are added, or your match will be
        automatically converted to{" "}
        {event?.players.length === 2 ? "individual match play" : "stroke Play"}
      </Text>
    );
  }

  return (
    <div>
      {teamsPlay && numberOfTeeTimes !== 1 && (
        <>
          {ballCount !== 0 && (
            <BallSwitch
              tabs={tabs}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
            />
          )}
          {renderItem(activeTab === 0 ? 0 : 1)}
        </>
      )}

      {numberOfTeeTimes === 1 && (
        <>
          <MatchPlayHeader
            holeRemaining={holeRemaining()}
            stake={stake}
            competedMatch={competedMatch}
          />

          <MatchPlayMatchTabScorecard
            data={individualData?.find((u) => u?.uid === uid)}
            stake={stake ?? 0}
            teamsPlay={teamsPlay}
            teamData={teamsPlay && findTeamByUid(teamsData, uid)}
          />
        </>
      )}

      {/* )} */}
    </div>
  );
}

MatchPlay.propTypes = {
  ballCount: PropTypes.number,
  data: PropTypes.arrayOf([PropTypes.any]).isRequired,
  numberOfTeeTimes: PropTypes.number.isRequired,
  teams: PropTypes.shape({
    find: PropTypes.func,
    some: PropTypes.func,
  }).isRequired,
  teamsPlay: PropTypes.bool.isRequired,
  competedMatch: PropTypes.bool,
};

MatchPlay.defaultProps = {
  competedMatch: false,
  ballCount: null,
};
